<template src="./ReportConfigList.html"></template>
<script>
import { createNamespacedHelpers } from "vuex";
import { orderBy } from "@progress/kendo-data-query";
const { mapState } = createNamespacedHelpers("reportConfig");
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";
import CommandCell from "@/components/CommandCellTemplate/CommandCellEditTemplate";
import { saveExcel } from "@progress/kendo-vue-excel-export";
export default {
  data: function () {
    return {
      title: null,
      gridHeight: window.innerHeight - 120,
      gridData: [],
      searchText: "",
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      add: true,
      sort: [{ field: "name", dir: "asc" }],
      filteredColumns: [],
      columns: [
        { hidden: false, field: "name", title: "name", width: "150px", checked: true, defaultSelected: true,},
        { hidden: false, field: "description", title: "Description", width: "180px", checked: true, defaultSelected: true,},
        { hidden: false, field: "reportGroupID", cell: this.groupName, title: "Report Group", width: "120px", checked: true, defaultSelected: true,},
        { hidden: false, field: "isVisible", cell: this.convertBoolean, title: "Visible", width: "90px", checked: true, defaultSelected: true,},
        { hidden: false, field: "isClientSpecific", cell: this.convertBoolean, title: "Client Specific", width: "100px", checked: true, defaultSelected: true,},
        { hidden: false, cell: CommandCell, width: '75px', locked: true, title: "Actions",  ignoreCheckbox: true, },
      ],
      dataItems: [],
    };
  },
  methods: {
    getDataOnload() {
      this.$store.dispatch("reportConfig/getInitialData", this.initialData)
      this.$store.dispatch("reportConfig/getReports", this.reportList);
    },
    groupName: function(h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      if(this.initialData.reportGroups) {
        const grp = this.initialData.reportGroups.find((t) => t.id === value);
        return h("td", {}, grp ? grp.name : '');
      }
    },
    convertBoolean: function(h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, 'No');
      } else {
          return h("td", {}, 'Yes');
      }
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    showAdd: function() {
      this.add = true;
    },
    goToAddPage: function() {
      this.$router.push({ name: "addReport", params: { add: true } });
    },
    edit: function(item) {
      return this.$store.dispatch("reportConfig/editReport", item.dataItem); //item.dataItem.id
    },
    exportExcel(){
      let arr = this.reportList.map(it => {
        return {
          ...it,
          reportGroupID: this.initialData.reportGroups.filter((dev) =>
            it.reportGroupID.includes(dev.id + '')
          ).map(a => a.name).join(','),
          isClientSpecific: it.isClientSpecific? "Yes": "No",
          isVisible: it.isVisible? "Yes": "No",
        }
      });
      saveExcel({
        data: arr,
        fileName: "Report",
        columns:this.columns
      });
    },
  },
  computed: {
    ...mapState(["loader", "reportList", "initialData"]),
    reportListVal() {
      return this.reportList.filter(
        (data) =>
          JSON.stringify(data)
            .toLowerCase()
            .indexOf(this.searchText.toLowerCase()) !== -1
      );
    },
    items: {
      get: function () {
        return orderBy(
          this.reportListVal.slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
    total() {
      return this.reportList ? this.reportList.length : 0;
    },
  },
  mounted() {
    this.getDataOnload();
  },
  beforeMount() {
    const eListColumns = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEYS.REPORT_MANAGEMENT)
    );
    if (!eListColumns) {
      this.filteredColumns = this.columns;
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find((c) => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,
              hidden: obj.hidden,
              checked: obj.checked,
            });
          } else {
            items.push({ ...col });
          }
      });
      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.filteredColumns = items;
    }
  },
};
</script>

<style lang="scss" scoped>
.search_mobile {
  width: 15% !important;
  border-radius: 5px;
}
@media only screen and (max-width: 768px) {
  .search_mobile {
    width: 40% !important;
  }
  .mobile_hide_show {
    display: none;
  }
  .driver_header_mobile {
    flex-direction: row !important;
    padding: 10px 10px 10px 10px;
  }
  .page-header .title-text {
    font-size: 12px;
  }
}
</style>